import {
  hasKey,
  isDataValid,
  isDefined,
  isFunction,
  logStdout,
  string2json,
  toNumber
} from "../../../shared/utils";
import fileSys from "../../../fileoprators/fileSystem";
import { json2CSV, makeCSVpath, mkdir } from "./funcs";
import { getAllRecordsOfPatientWithContent, getRecordContent } from "../../../services/record";
import { EventEmitter } from "eventemitter3";
import { downloadMedia } from "../../../services/media";
import {
  QuestionnaireDryEyeMain,
  QuestionnaireOSDI,
  QuestionnaireArr
} from "../../../dryeye/js/questionNaire";

function initDryEyeHeaders() {
  const table = {
    Name: "",
    Pid: "",
    CheckTime: "",
    EYE: "",
    Questionnaire: "",
    Nibut_First_Rupture_Time: "",
    Nibut_AVG_Rupture_Time: "",
    TearHeight_Auto: "",
    TearHeight_Manual: "",
    TearHeight_TearArea: "",
    LipidLayer_Level: "",
    Meibomian_Up_GlandRatio: "",
    Meibomian_Up_GlandLoss: "",
    Meibomian_Up_Score: "",
    Meibomian_Down_GlandRatio: "",
    Meibomian_Down_GlandLoss: "",
    Meibomian_Down_Score: "",
    EyelidEdge_Up_Score: "",
    EyelidEdge_Down_Score: "",
    EyelidEdge_Note: "",
    EyeRedness_CiliaryCongestion_N: "",
    EyeRedness_CiliaryCongestion_T: "",
    EyeRedness_ConjunctivalCongestion_N: "",
    EyeRedness_ConjunctivalCongestion_T: "",
    Fbut_First_AVG_Rupture_Time: "",
    Blink_Frequency: "",
    Complete_Blink_Times: "",
    Partial_Blink_Times: "",
    Inter_Blink_Interval: "",
    Partial_Blink_Rate: "",
    EyeRedness_Note: "",
    Surface_Note: ""
  };
  let headers = [];
  for (let id in table) {
    headers.push(id);
  }

  return { headers };
}
function normalPatientName(patient) {
  return `${patient.firstname}${
    patient.lastname && patient.lastname !== "" ? " " + patient.lastname : ""
  }`.trim();
}
export default class ExportDryEyeAPI extends EventEmitter {
  constructor(storagePath, options, patients = [], unSelectedRecords = []) {
    super();
    this.storagePath = storagePath;
    this.folderName = options.folderName;
    this.exportOptions = options.exportOptions;
    this.dataShowSettings = options.dataShowSettings;
    this.patients = patients;
    this.unSelectedRecords = unSelectedRecords;
    this.langcfg = options.langcfg;
    this.dryEyeHeaders = initDryEyeHeaders();
    this.csvData = [];
    this.isExporting = true;
    this.exportCount = 0;
  }
  stopExport() {
    this.isExporting = false;
  }
  tearAreaAuto(tearheight) {
    const autocalcarea = tearheight.autocalcarea;
    let deal = autocalcarea * Math.pow(window.magecoe.tearheight, 2);
    if (!isDefined(autocalcarea) || autocalcarea === -1) {
      return "--";
    } else {
      return deal.toFixed(2) + "mm^2";
    }
  }
  getGlandLoss(glandloss) {
    const glandlossVal = glandloss === 0 ? 0 : Math.floor(glandloss * 1000) / 10;
    const val =
      glandlossVal === 0
        ? 0
        : glandlossVal > 0 && glandlossVal <= 33
          ? 1
          : glandlossVal > 33 && glandlossVal <= 66
            ? 2
            : 3;
    return val;
  }
  tableName(currentPatient, patient, eyeType) {
    let record = patient.content[`data${eyeType}`];
    let QNR = patient.content["userQuestionnaire"];
    let table = {
      Name: "",
      Pid: "",
      CheckTime: "",
      EYE: "",
      Questionnaire: "",
      Nibut_First_Rupture_Time: "",
      Nibut_AVG_Rupture_Time: "",
      TearHeight_Auto: "",
      TearHeight_Manual: "",
      TearHeight_TearArea: "",
      LipidLayer_Level: "",
      Meibomian_Up_GlandRatio: "",
      Meibomian_Up_GlandLoss: "",
      Meibomian_Up_Score: "",
      Meibomian_Down_GlandRatio: "",
      Meibomian_Down_GlandLoss: "",
      Meibomian_Down_Score: "",
      EyelidEdge_Up_Score: "",
      EyelidEdge_Down_Score: "",
      EyelidEdge_Note: "",
      EyeRedness_CiliaryCongestion_N: "",
      EyeRedness_CiliaryCongestion_T: "",
      EyeRedness_ConjunctivalCongestion_N: "",
      EyeRedness_ConjunctivalCongestion_T: "",
      Fbut_First_AVG_Rupture_Time: "",
      Blink_Frequency: "",
      Complete_Blink_Times: "",
      Partial_Blink_Times: "",
      Inter_Blink_Interval: "",
      Partial_Blink_Rate: "",
      EyeRedness_Note: "",
      Surface_Note: ""
    };
    if (QNR) {
      if (QNR.hasOwnProperty("DEQ") && QNR.DEQ.length > 0) {
        let DEQ = QuestionnaireArr(QNR.DEQ, "DEQ");
        let str = this.langcfg[`${DEQ.bkStr}`];
        table.Questionnaire += `DEQ: ${DEQ.num} ${str}; `;
      }
      if (QNR.hasOwnProperty("DryEyeMain") && QNR.DryEyeMain.length > 0) {
        let DryEyeMain = QuestionnaireDryEyeMain(QNR.DryEyeMain);
        let str = this.langcfg[`${DryEyeMain.bkStr}`];
        table.Questionnaire += `DryEyeMain: ${DryEyeMain.num} ${str}; `;
      }
      if (QNR.hasOwnProperty("McMonnies") && QNR.McMonnies.length > 0) {
        let McMonnies = QuestionnaireArr(QNR.McMonnies, "McMonnies");
        let str = this.langcfg[`${McMonnies.bkStr}`];
        table.Questionnaire += `McMonnies: ${McMonnies.num} ${str}; `;
      }
      if (QNR.hasOwnProperty("OSDI") && QNR.OSDI.length > 0) {
        let OSDI = QuestionnaireOSDI(QNR.OSDI);
        let str = this.langcfg[`${OSDI.bkStr}`];
        table.Questionnaire += `OSDI: ${OSDI.Osumtext} ${str}; `;
      }
      if (QNR.hasOwnProperty("Speed") && QNR.Speed.length > 0) {
        let Speed = QuestionnaireArr(QNR.Speed, "Speed");
        let str = this.langcfg[`${Speed.bkStr}`];
        table.Questionnaire += `Speed: ${Speed.num} ${str}; `;
      }
    }
    if (record) {
      let trensdDataYHeigth;
      let curTearHeight;
      let tearHeightAuto;
      let tearArea;
      if (record.hasOwnProperty("tearheight")) {
        if (record.tearheight.hasOwnProperty("trensdDataYHeigth")) {
          trensdDataYHeigth = record.tearheight.trensdDataYHeigth;
        }
        if (record.tearheight.hasOwnProperty("clonetrensdDataYHeigth")) {
          trensdDataYHeigth = record.tearheight.clonetrensdDataYHeigth;
        }
        if (
          !record.tearheight.hasOwnProperty("trensdDataYHeigth") &&
          !record.tearheight.hasOwnProperty("clonetrensdDataYHeigth")
        ) {
          trensdDataYHeigth = undefined;
        }
        curTearHeight =
          isDefined(record.tearheight.manualMeasureAvg) && record.tearheight["manualMeasureAvg"] > 0
            ? Math.round(record.tearheight.manualMeasureAvg * 100) / 100
            : undefined;
        tearHeightAuto =
          trensdDataYHeigth === undefined || trensdDataYHeigth === null || trensdDataYHeigth < 0
            ? undefined
            : window.magecoe.tearheight * trensdDataYHeigth;
        tearArea = this.tearAreaAuto(record.tearheight);
      }
      const name =
        currentPatient.firstname && currentPatient.firstname.lastname
          ? currentPatient.firstname + "_" + currentPatient.lastname
          : currentPatient.firstname;
      let LipidLevel;
      if (record.hasOwnProperty("lipidlayer") && record.lipidlayer.hasOwnProperty("level")) {
        if (record.lipidlayer.level === 1) {
          LipidLevel = "1" + "(<30 nm)";
        } else if (record.lipidlayer.level === 2) {
          LipidLevel = "2" + "(30 - 60 nm)";
        } else if (record.lipidlayer.level === 3) {
          LipidLevel = "3" + "(60 - 80 nm)";
        } else if (record.lipidlayer.level === 4) {
          LipidLevel = "4" + "(>80 nm)";
        }
      }
      let eyelidUpLevel;
      if (record.hasOwnProperty("eyelidedge") && record.eyelidedge.hasOwnProperty("up")) {
        if (record.eyelidedge.up.level === "1") {
          eyelidUpLevel = "1" + "(Normal)";
        } else if (record.eyelidedge.up.level === "2") {
          eyelidUpLevel = "2" + "(Mild)";
        } else if (record.eyelidedge.up.level === "3") {
          eyelidUpLevel = "3" + "(Moderate)";
        } else if (record.eyelidedge.up.level === "4") {
          eyelidUpLevel = "4" + "(Severe)";
        }
      }
      let eyelidDownLevel;
      if (record.hasOwnProperty("eyelidedge") && record.eyelidedge.hasOwnProperty("down")) {
        if (record.eyelidedge.down.level === "1") {
          eyelidDownLevel = "1" + "(Normal)";
        } else if (record.eyelidedge.down.level === "2") {
          eyelidDownLevel = "2" + "(Mild)";
        } else if (record.eyelidedge.down.level === "3") {
          eyelidDownLevel = "3" + "(Moderate)";
        } else if (record.eyelidedge.down.level === "4") {
          eyelidDownLevel = "4" + "(Severe)";
        }
      }
      let firstrupturetime = "";
      let firstavgruptrure = "";
      if (record.hasOwnProperty("nibut") && record.nibut.hasOwnProperty("firstrupturetime")) {
        if (record.nibut.firstrupturetime >= 10000) {
          firstrupturetime = record.nibut.usefultime
            ? `>${record.nibut.usefultime.toFixed(1)}s`
            : ">21s";
        } else {
          firstrupturetime = record.nibut.firstrupturetime.toFixed(2) + "s";
        }
      } else {
        firstrupturetime = "";
      }

      if (record.hasOwnProperty("nibut") && record.nibut.hasOwnProperty("avgruptruretime")) {
        if (record.nibut.avgruptruretime >= 10000) {
          firstavgruptrure = record.nibut.usefultime
            ? `>${record.nibut.usefultime.toFixed(1)}s`
            : ">21s";
        } else {
          firstavgruptrure = record.nibut.avgruptruretime.toFixed(2) + "s";
        }
      } else {
        firstavgruptrure = "";
      }
      table.Name = name;
      table.Pid = currentPatient.pid;
      table.CheckTime = record.recordtime ? record.recordtime : patient.recorddate;
      table.EYE = eyeType;
      table.Nibut_First_Rupture_Time = firstrupturetime || "--";
      table.Nibut_AVG_Rupture_Time = firstavgruptrure || "--";
      table.TearHeight_Auto = tearHeightAuto ? tearHeightAuto.toFixed(2) + "mm" : "--";
      table.TearHeight_Manual = curTearHeight !== undefined ? curTearHeight + "mm" : "--";
      table.TearHeight_TearArea = tearArea;
      table.LipidLayer_Level = LipidLevel;

      if (record.hasOwnProperty("meibomian") && record.meibomian.hasOwnProperty("up")) {
        table.Meibomian_Up_GlandRatio =
          record.meibomian.up.glandpercent === 0
            ? 0
            : Math.floor(record.meibomian.up.glandpercent * 1000) / 10 + "%";
        table.Meibomian_Up_GlandLoss =
          record.meibomian.up.glandloss === 0
            ? 0
            : Math.floor(record.meibomian.up.glandloss * 1000) / 10 + "%";
        table.Meibomian_Up_Score = record.meibomian.up.gland_grade;
        table.Meibomian_Up_Score = this.getGlandLoss(record.meibomian.up.glandloss);
      }
      if (record.hasOwnProperty("meibomian") && record.meibomian.hasOwnProperty("down")) {
        table.Meibomian_Down_GlandRatio =
          record.meibomian.down.glandpercent === 0
            ? 0
            : Math.floor(record.meibomian.down.glandpercent * 1000) / 10 + "%";
        table.Meibomian_Down_GlandLoss =
          record.meibomian.down.glandloss === 0
            ? 0
            : Math.floor(record.meibomian.down.glandloss * 1000) / 10 + "%";
        // table.Meibomian_Down_Score = record.meibomian.down.gland_grade
        table.Meibomian_Down_Score = this.getGlandLoss(record.meibomian.down.glandloss);
      }
      if (record.hasOwnProperty("fbut")) {
        let fbut = record.fbut;
        if (
          fbut.length === 3 &&
          (fbut[0].firstrupturetime || fbut[0].firstrupturetime == 0) &&
          (fbut[1].firstrupturetime || fbut[1].firstrupturetime == 0) &&
          (fbut[2].firstrupturetime || fbut[2].firstrupturetime == 0)
        ) {
          let num1 = fbut[0].firstrupturetime;
          let num2 = fbut[1].firstrupturetime;
          let num3 = fbut[2].firstrupturetime;
          if (fbut[0].firstrupturetime === 10000) {
            num1 = fbut[0].usefultime ? Number(fbut[0].usefultime.toFixed(2)) : 21;
          }
          if (fbut[1].firstrupturetime === 10000) {
            num2 = fbut[1].usefultime ? Number(fbut[1].usefultime.toFixed(2)) : 21;
          }
          if (fbut[2].firstrupturetime === 10000) {
            num3 = fbut[2].usefultime ? Number(fbut[2].usefultime.toFixed(2)) : 21;
          }
          let averagenum = (num1 + num2 + num3).toFixed(2);
          table.Fbut_First_AVG_Rupture_Time = `${(averagenum / 3).toFixed(2)}s`;
        } else if (
          fbut.length === 1 &&
          (fbut[0].firstrupturetime || fbut[0].firstrupturetime == 0)
        ) {
          let num = fbut[0].firstrupturetime.toFixed(2);
          if (fbut[0].firstrupturetime === 10000) {
            num = fbut[0].usefultime ? Number(fbut[0].usefultime.toFixed(2)) : 21;
          }
          table.Fbut_First_AVG_Rupture_Time = `${num}s`;
        }
      }
      table.EyelidEdge_Up_Score = eyelidUpLevel;
      table.EyelidEdge_Down_Score = eyelidDownLevel;
      table.EyelidEdge_Note =
        record.hasOwnProperty("eyelidedge") && record.eyelidedge.hasOwnProperty("note")
          ? record.eyelidedge.note
          : "--";
      table.EyeRedness_CiliaryCongestion_N =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("nasalciliary")
          ? record.eyeredness.nasalciliary.toFixed(2)
          : "--";
      table.EyeRedness_CiliaryCongestion_T =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("tempciliary")
          ? record.eyeredness.tempciliary.toFixed(2)
          : "--";
      table.EyeRedness_ConjunctivalCongestion_N =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("nasalconjunctival")
          ? record.eyeredness.nasalconjunctival.toFixed(2)
          : "--";
      table.EyeRedness_ConjunctivalCongestion_T =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("tempconjunctival")
          ? record.eyeredness.tempconjunctival.toFixed(2)
          : "--";
      table.EyeRedness_Note =
        record.hasOwnProperty("eyeredness") && record.eyeredness.hasOwnProperty("note")
          ? record.eyeredness.note
          : "--";
      table.Surface_Note =
        record.hasOwnProperty("ocularsurface") && record.ocularsurface.hasOwnProperty("note")
          ? record.ocularsurface.note
          : "--";
      table.Blink_Frequency =
        record.hasOwnProperty("blink") && record.blink.hasOwnProperty("NumTotalBlk")
          ? `${Number(record.blink.NumTotalBlk.toFixed())}`
          : "--";
      table.Complete_Blink_Times =
        record.hasOwnProperty("blink") && record.blink.hasOwnProperty("NumCmpltBlk")
          ? `${Number(record.blink.NumCmpltBlk.toFixed())}`
          : "--";
      table.Partial_Blink_Times =
        record.hasOwnProperty("blink") && record.blink.hasOwnProperty("NumNocmpltBlk")
          ? `${Number(record.blink.NumNocmpltBlk.toFixed())}`
          : "--";
      table.Inter_Blink_Interval =
        record.hasOwnProperty("blink") &&
        record.blink.hasOwnProperty("videoTime") &&
        table.Blink_Frequency !== "--"
          ? `${Number(record.blink.videoTime / table.Blink_Frequency).toFixed(1)}s`
          : "--";
      table.Partial_Blink_Rate =
        record.hasOwnProperty("blink") &&
        table.Blink_Frequency !== "--" &&
        table.Partial_Blink_Times !== "--"
          ? `${Number(table.Partial_Blink_Times).toFixed(1)} / ${Number(
              table.Blink_Frequency
            ).toFixed(1)}`
          : "--";
      // this.saveUserDryeyeTable.push(table)
      return table;
    }
  }
  exportRecords(patient, records, callback) {
    if (records.length <= 0) {
      if (callback) callback();
    } else {
      const record = records.pop();
      if (this.unSelectedRecords[record._id]) {
        if (this.isExporting) this.exportRecords(patient, records, callback);
      } else {
        this.exportOneDryEye(patient, record, ["OS", "OD"], () => {
          if (this.isExporting) this.exportRecords(patient, records, callback);
        });
      }
    }
  }
  exportPatients(callback) {
    if (this.patients.length <= 0) {
      const { dryeyecsv } = this.exportOptions.dryeye.children;
      if (dryeyecsv && this.csvData.length > 0) {
        const csvPath = makeCSVpath(this.storagePath);

        json2CSV(this.dryEyeHeaders.headers, this.csvData, csvPath);
        this.csvData = [];
        if (callback) callback(this.isExporting);
      } else {
        if (callback) callback(this.isExporting);
      }
    } else {
      const patient = this.patients.pop();
      if (!this.isExporting) return;
      getAllRecordsOfPatientWithContent(patient._id, { checktype: "dryeye" }, (res) => {
        if (res.message === "OK") {
          const { records } = res;
          this.exportRecords(patient, records.concat(), () => {
            fileSys.syncImmediate(() => {
              fileSys.clearCache(() => {
                if (this.isExporting) this.exportPatients(callback);
              });
            });
          });
        } else {
          if (this.isExporting) this.exportPatients(callback);
        }
      });
    }
  }
  copyDryEye(photos, result, callback) {
    if (photos.length <= 0) {
      if (callback) callback();
    } else {
      let photo = photos.pop();
      let dstPhotoPath = fileSys.combinePath(result.path, photo.original);
      if (!this.isExporting) return;
      downloadMedia(photo.photo, dstPhotoPath)
        .then(() => {
          // let photoPath = fileSys.combinePath(fileSys.getMediaPath(photo.original))
          // let copyState = fileSys.copyFile(photoPath, dstPhotoPath)
          // if (copyState !== false) fileSys.deleteFile(photoPath)
          if (this.isExporting) this.copyDryEye(photos, result, callback);
        })
        .catch((e) => {
          if (this.isExporting) this.copyDryEye(photos, result, callback);
        });
    }
  }
  exportOneDryEye(patient, record, osods = ["OS", "OD"], callback) {
    if (osods.length <= 0) {
      this.emit("export-count", normalPatientName(patient) + "_" + record.recorddate);
      if (callback) callback();
    } else {
      let osod = osods.pop();

      if (
        hasKey(record, `content.data${osod}.diagnosed`) &&
        record.content[`data${osod}`].diagnosed
      ) {
        let iv = [];
        const {
          dryeyecsv,
          tearheight,
          nibut,
          lipidlayer,
          meibomian,
          eyelidedge,
          eyeredness,
          blink,
          fbut,
          ocularsurface
        } = this.exportOptions.dryeye.children;
        if (dryeyecsv) {
          this.csvData.push(this.tableName(patient, record, osod));
        }
        if (
          tearheight ||
          nibut ||
          lipidlayer ||
          meibomian ||
          eyelidedge ||
          eyeredness ||
          blink ||
          fbut ||
          ocularsurface
        ) {
          const result = mkdir(
            this.folderName,
            this.storagePath,
            patient,
            record,
            osod,
            this.langcfg
          );
          if (result.message === "ok") {
            if (
              tearheight &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.tearheight.diagnosed`) &&
              record.content[`data${osod}`].tearheight.diagnosed &&
              record.content[`data${osod}`].tearheight.photos
            ) {
              let photos = record.content[`data${osod}`].tearheight.photos;
              for (let index = 0; index < photos.length; index++) {
                if (photos[index].imagelabel === "original") {
                  iv.push({
                    photo: photos[index],
                    original: "tearheight.jpg"
                  });
                }
              }
            }
            if (
              nibut &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.nibut.diagnosed`) &&
              record.content[`data${osod}`].nibut.diagnosed &&
              record.content[`data${osod}`].nibut.photos
            ) {
              let photos = record.content[`data${osod}`].nibut.photos;
              for (let index = 0; index < photos.length; index++) {
                if (photos[index].mimetype === "video/mp4") {
                  iv.push({
                    photo: photos[index],
                    original: "nibut.mp4"
                  });
                }
              }
            }
            if (
              lipidlayer &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.lipidlayer.diagnosed`) &&
              record.content[`data${osod}`].lipidlayer.diagnosed &&
              record.content[`data${osod}`].lipidlayer.photos
            ) {
              let photos = record.content[`data${osod}`].lipidlayer.photos;
              for (let index = 0; index < photos.length; index++) {
                if (
                  photos[index].imagelabel === "original" ||
                  photos[index].mimetype === "video/mp4"
                ) {
                  iv.push({
                    photo: photos[index],
                    original:
                      photos[index].imagelabel === "original" ? "lipidlayer.jpg" : "lipidlayer.mp4"
                  });
                }
              }
            }
            if (
              meibomian &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.meibomian.diagnosed`) &&
              record.content[`data${osod}`].meibomian.diagnosed
            ) {
              if (
                record.content[`data${osod}`].meibomian.up &&
                record.content[`data${osod}`].meibomian.up.photos
              ) {
                let photos = record.content[`data${osod}`].meibomian.up.photos;
                for (let index = 0; index < photos.length; index++) {
                  if (photos[index].imagelabel === "original") {
                    iv.push({
                      photo: photos[index],
                      original: "meibomian_up.jpg"
                    });
                  }
                }
              }
              if (
                record.content[`data${osod}`].meibomian.down &&
                record.content[`data${osod}`].meibomian.down.photos
              ) {
                let photos = record.content[`data${osod}`].meibomian.down.photos;
                for (let index = 0; index < photos.length; index++) {
                  if (photos[index].imagelabel === "original") {
                    iv.push({
                      photo: photos[index],
                      original: "meibomian_down.jpg"
                    });
                  }
                }
              }
            }
            if (
              eyelidedge &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.eyelidedge.diagnosed`) &&
              record.content[`data${osod}`].eyelidedge.diagnosed
            ) {
              if (
                record.content[`data${osod}`].eyelidedge.up &&
                record.content[`data${osod}`].eyelidedge.up.photos
              ) {
                let photos = record.content[`data${osod}`].eyelidedge.up.photos;
                for (let index = 0; index < photos.length; index++) {
                  if (photos[index].imagelabel === "original") {
                    iv.push({
                      photo: photos[index],
                      original: "eyelidedge_up.jpg"
                    });
                  }
                }
              }
              if (
                record.content[`data${osod}`].eyelidedge.down &&
                record.content[`data${osod}`].eyelidedge.down.photos
              ) {
                let photos = record.content[`data${osod}`].eyelidedge.down.photos;
                for (let index = 0; index < photos.length; index++) {
                  if (photos[index].imagelabel === "original") {
                    iv.push({
                      photo: photos[index],
                      original: "eyelidedge_down.jpg"
                    });
                  }
                }
              }
            }
            if (
              eyeredness &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.eyeredness.diagnosed`) &&
              record.content[`data${osod}`].eyeredness.diagnosed &&
              record.content[`data${osod}`].eyeredness.photos
            ) {
              let photos = record.content[`data${osod}`].eyeredness.photos;
              for (let index = 0; index < photos.length; index++) {
                if (photos[index].imagelabel === "original") {
                  iv.push({
                    photo: photos[index],
                    original: "eyeredness.jpg"
                  });
                }
              }
            }
            if (fbut && this.isExporting && record.content[`data${osod}`].hasOwnProperty("fbut")) {
              if (record.content[`data${osod}`].fbut.length > 1) {
                for (let i = 0; i < 3; i++) {
                  let photos = record.content[`data${osod}`].fbut[i].photos;
                  for (let index = 0; index < photos.length; index++) {
                    if (photos[index].mimetype === "video/mp4") {
                      iv.push({
                        photo: photos[index],
                        original: `fbut${i}.mp4`
                      });
                    }
                  }
                }
              } else {
                let photos = record.content[`data${osod}`].fbut[0].photos;
                for (let index = 0; index < photos.length; index++) {
                  if (photos[index].mimetype === "video/mp4") {
                    iv.push({
                      photo: photos[index],
                      original: "fbut.mp4"
                    });
                  }
                }
              }
            }
            if (
              blink &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.blink.diagnosed`) &&
              record.content[`data${osod}`].blink.diagnosed &&
              record.content[`data${osod}`].blink.photos
            ) {
              let photos = record.content[`data${osod}`].blink.photos;
              for (let index = 0; index < photos.length; index++) {
                if (photos[index].mimetype === "video/mp4") {
                  iv.push({
                    photo: photos[index],
                    original: "blink.mp4"
                  });
                }
              }
            }
            if (
              ocularsurface &&
              this.isExporting &&
              hasKey(record, `content.data${osod}.ocularsurface.diagnosed`) &&
              record.content[`data${osod}`].ocularsurface.diagnosed &&
              record.content[`data${osod}`].ocularsurface.photos
            ) {
              let photos = record.content[`data${osod}`].ocularsurface.photos;
              for (let index = 0; index < photos.length; index++) {
                if (photos[index].imagelabel === "original") {
                  iv.push({
                    photo: photos[index],
                    original: "ocularsurface.jpg"
                  });
                }
              }
            }
            this.copyDryEye(iv, result, () => {
              if (this.isExporting) this.exportOneDryEye(patient, record, osods, callback);
            });
          } else {
            if (this.isExporting) this.exportOneDryEye(patient, record, osods, callback);
          }
        } else {
          if (this.isExporting) this.exportOneDryEye(patient, record, osods, callback);
        }
      } else {
        if (this.isExporting) this.exportOneDryEye(patient, record, osods, callback);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mainInterface/components/exportData/exportDryEyeApi.js